import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CookiesService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) {}

  setCookie(name: string, value: string, seconds: number = -1) {
    let liveTime;
    if (seconds === -1) {
      liveTime = 'max-age=-1';
    } else {
      const date = new Date(seconds * 1000);
      liveTime = `expires=${date.toUTCString()}`;
    }
    this.document.cookie = `${name}=${value}; ${liveTime}; path=/`;
  }

  getCookie(name: string) {
    const nameEQ = name + '=';
    const ca = this.document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return false;
  }
}
